import React from 'react';
import { FaWallet } from 'react-icons/fa';
import './UserBalanceDisplay.scss';

interface UserBalanceDisplayProps {
  balance: number;
  loading?: boolean;
}

const UserBalanceDisplay: React.FC<UserBalanceDisplayProps> = ({ balance, loading }) => {
  const formatNumber = (num: number): string => {
    if (num >= 1000000) {
      return `${(num / 1000000).toFixed(1)}M`;
    }
    if (num >= 1000) {
      return `${(num / 1000).toFixed(1)}K`;
    }
    return num.toLocaleString();
  };

  if (loading) {
    return (
      <div className="user-balance-display loading">
        <div className="balance-icon-skeleton"></div>
        <div className="balance-content">
          <div className="balance-label-skeleton"></div>
          <div className="balance-value-skeleton"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="user-balance-display">
      <div className="balance-icon">
        <FaWallet />
      </div>
      <div className="balance-content">
        <span className="balance-label">Your Balance</span>
        <span className="balance-value">{formatNumber(balance)} KLV</span>
      </div>
    </div>
  );
};

export default UserBalanceDisplay;
